import { Injectable, signal } from '@angular/core';

import layerNames from '../../assets/modes.json';
const castLayerNames = layerNames as any;

import bronHouders from '../../assets/bronhouders.json';
const castBronHouders = bronHouders as any;

@Injectable({
  providedIn:'root'
})
export class InfocardService {
  // Signals, so the infocard re-renders without zone.js.
  public readonly isOpen = signal(false);
  public readonly data = signal<any>(null);
  public readonly displayName = signal<string>(undefined);
  public readonly displayDescription = signal<string>(undefined);
  public layerNames = castLayerNames;
  public bronHouders = castBronHouders;

  public open(data, mode) {
    this.displayName.set(this.mapModeToDisplayName(mode));
    this.displayDescription.set(this.mapModeToDescription(mode));
    if (data.properties.vbos) {
      data.properties.streets = this.parseVboData(data.properties.vbos);
    }
    this.data.set(data);
    this.isOpen.set(true);
  }

  private parseVboData(vboData){
    const adresData = JSON.parse(JSON.stringify(vboData));
    const nonUniqueStreets = adresData.map(adres => adres.properties.openbare_ruimte);
    const uniqueStreets = Array.from(new Set(nonUniqueStreets));
    return uniqueStreets;
  }

  public close() {
    this.isOpen.set(false);
  }

  private mapModeToDisplayName(mode) {
    return this.layerNames.find((layerName) => {
      return layerName.layer === mode;
    }).displayName;
  }

  private mapModeToDescription(mode) {
    return this.layerNames.find((layerName) => {
      return layerName.layer === mode;
    }).description;
  }

  public mapBronhoudercode(code) {
    return this.bronHouders.find((bronhouder) => {
      return bronhouder.BGTcode === code;
    }).Naam;
  }

}
